import React from 'react'

import Theme from '@theme'

interface IProps {
  percentage: number
  size?: number
}

const AudienceAgeDonut: React.FC<IProps> = ({ percentage, size = 32 }) => {
  const radius = 14
  const circumference = 2 * Math.PI * radius
  const clamped = Math.max(0, Math.min(100, percentage))
  const dash = (clamped / 100) * circumference

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <circle
        cx={16}
        cy={16}
        r={radius}
        fill="transparent"
        stroke={Theme.secondary500Color}
        strokeWidth={4}
      />
      <circle
        cx={16}
        cy={16}
        r={radius}
        fill="transparent"
        stroke={Theme.primaryColor}
        strokeWidth={4}
        strokeDasharray={`${dash} ${circumference - dash}`}
        strokeDashoffset={circumference / 4}
        transform="rotate(-90 16 16)"
      />
    </svg>
  )
}

export { AudienceAgeDonut }
export default AudienceAgeDonut
